import { INTERNAL_FEATURE, LOCAL_DEV, OFF } from './toggles-constants';

// builder toggles - updates available/diff/merge projects
export const TOGGLE_BLOCKING_POPUPS = OFF;

// builder toggles — not ready to release for a while
export const TOGGLE_REMOVE_SESSION_REFRESHER = INTERNAL_FEATURE;
export const TOGGLE_REPLACE_RESULTS = OFF;
export const TOGGLE_PAGE_BUILDER_ATTRIBUTE_SORTING = INTERNAL_FEATURE;
export const TOGGLE_SOURCE_SYNCING_CROSS_TAB = OFF; // doesn't account for local disk mode — needs review before we turn this on
export const TOGGLE_FLATTEN_SINGLETON_TYPES = OFF;
export const TOGGLE_CUSTOM_KEYBOARD_SHORTCUTS = OFF;
export const TOGGLE_SCRIPT_QUICK_VIEW = LOCAL_DEV && INTERNAL_FEATURE; // also only if DevsiteEnv.SCRIPT_PREVIEW_URL is configured for this env
export const TOGGLE_LINE_TRANSLATIONS_VISUAL_MODE = OFF;

// builder toggles - Read-Only Components
export const TOGGLE_READ_ONLY_SECURITY_DOMAIN = INTERNAL_FEATURE;
export const TOGGLE_READ_ONLY_TASK = INTERNAL_FEATURE;
export const TOGGLE_READ_ONLY_PROFILE_GROUP = INTERNAL_FEATURE;
export const TOGGLE_READ_ONLY_CARD_TENANT_SETTINGS = INTERNAL_FEATURE;
export const TOGGLE_READ_ONLY_BUSINESS_OBJECT = INTERNAL_FEATURE;
export const TOGGLE_READ_ONLY_ATTACHMENTS = INTERNAL_FEATURE;
export const TOGGLE_READ_ONLY_BUSINESS_PROCESS = INTERNAL_FEATURE;

// builder toggles - Agent Builder
export const TOGGLE_AGENT_PREVIEW_PANEL = INTERNAL_FEATURE;
export const TOGGLE_ORCH_BUILDER_BUTTON = INTERNAL_FEATURE;
